

interface CreateButtonProps {
    handleCreateButtonClick: () => void;
    createButtonText: string;
}

export const CreateButton = ({
    handleCreateButtonClick,
    createButtonText,
}: CreateButtonProps) => {

    return (
        <button
            onClick={handleCreateButtonClick}
            style={{
                backgroundColor: "#3B82F6",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                padding: "10px 20px",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontFamily: "Quicksand",
                transition: "background-color 0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#2563EB")}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
        >
            {createButtonText}
        </button>
    );
}